module.exports = __webpack_public_path__ + "static/BasisGrotesquePro-Light.5abf72ab.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/BasisGrotesquePro-Light.woff
// module id = 706
// module chunks = 168707334958949